import {Icon} from "@mui/material";

export const XmlDocumentIcons = ({size}) => {
  return (
    <Icon style={{height: parseInt(size), width: parseInt(size)}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
      }} src="/icons/xml.svg"/>
    </Icon>
  )
}

export const BusinessCardIcon = ({size}) => {
  return (
    <Icon style={{height: parseInt(size), width: parseInt(size)}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
      }} src="/icons/b_card.svg"/>
    </Icon>
  )
}

export const WarningIcon = ({size}) => {
  return (
    <Icon style={{height: parseInt(size), width: parseInt(size)}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
      }} src="/icons/warning.svg"/>
    </Icon>
  )
}

export const OkIcon = ({size}) => {
  return (
    <Icon style={{height: parseInt(size), width: parseInt(size)}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit',
      }} src="/icons/ok.svg"/>
    </Icon>
  )
}

export const SuccessIcon = ({size, verticalAlign}) => {
  return (
    <Icon style={{height: parseInt(size), width: parseInt(size), verticalAlign, textDecoration: 'none'}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit',
      }} src="/icons/success.svg"/>
    </Icon>
  )
}

export const EditIcon = ({size, vAlign}) => {
  return (
    <Icon style={{height: parseInt(size), width: parseInt(size), verticalAlign: vAlign}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
      }} src="/icons/edit.svg"/>
    </Icon>
  )
}

export const CrossIcon = ({size, vAlign}) => {
  return (
    <Icon style={{height: parseInt(size), width: parseInt(size), verticalAlign: vAlign}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
      }} src="/icons/cross.svg"/>
    </Icon>
  )
}

export const ExitIcon = ({size, vAlign}) => {
  return (
    <Icon style={{height: parseInt(size), width: parseInt(size), verticalAlign: vAlign}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
      }} src="/icons/exit.svg"/>
    </Icon>
  )
}

export const NextRightIcon = ({size}) => {
  return (
    <Icon style={{height: parseInt(size), width: parseInt(size)}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
      }} src="/icons/nextRight.svg"/>
    </Icon>
  )
}

export const PdfGrayIcon = ({size}) => {
  return (
    <Icon style={{height: parseInt(size || 10), width: parseInt(size || 10)}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
      }} src="/icons/pdfGray.svg"/>
    </Icon>
  )
}

export const DocumentTypeIcon = ({size, format, fileName}) => {
  const map = {
    "png": "png.svg",
    "pdf": "pdf.svg",
    "xml": "xml.svg",
    "jpg": "jpg.svg",
    "doc": "doc.svg",
    "docx": "doc.svg",
  }

  if(fileName) {
    const f = fileName.split('.')
    format = f[f.length-1];
  }

  let src;

  if(map[format])
    src = `/icons/${map[format]}`;
  else
    src = `/icons/file.svg`;

  return (
    <Icon style={{height: parseInt(size), width: parseInt(size)}}>
      <img style={{
        display: 'flex',
        height: 'inherit',
        width: 'inherit'
      }} src={src}/>
    </Icon>
  )
};